import type { Canvas } from "./types";

/**
 * Public viewer page of a canvas whose link is on — the link to give a
 * person. `fallback` is the client-built URL for servers that predate
 * `view_url`; delete it once no such server is deployed.
 */
export function resolveCanvasViewUrl(
  canvas: Pick<Canvas, "view_url" | "published_url"> | undefined,
  fallback: () => string,
): string {
  return canvas?.view_url || canvas?.published_url || fallback();
}
